import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { DeviceWidth } from 'ecs-react-components/dist/index.es';
import SecureMessages from '../../containers/SecureMessage/SecureMessages';
import SecureMessagesCompact from '../../containers/SecureMessage/SecureMessagesCompact';
import { loadMessageThreads } from '../../redux/modules/secure-message/secure-message-middleware';
import { auditRequest } from '../../redux/modules/audit/audit-middleware';
import { generateListItems } from '../../containers/SecureMessage/SecureMessagesConfig';
import { showSecureMessageReplyItem } from '../../redux/modules/secure-message/actions/creators';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';

const SECURE_MESSAGE_VIEW_AUDIT_TYPE = 'securemessageviewauditevent';

export class SecureMessagePage extends React.Component {
  UNSAFE_componentWillMount() {
    const { language, timeZone, timeZoneOffset, patientId } = this.props;
    this.props.dispatch(callWithLoadingIndicator(
      'SecureMessagePage',
      () => this.props.dispatch(loadMessageThreads(patientId, language, timeZone, timeZoneOffset))));
    this.props.dispatch(auditRequest(SECURE_MESSAGE_VIEW_AUDIT_TYPE, patientId));
    this.props.dispatch(showSecureMessageReplyItem(false));
  }

  getComponentBySize() {
    const { windowSize } = this.props;
    const listItems = generateListItems(this.props.threads, this.props.filter);
    const compactView = windowSize === DeviceWidth.Small.name
      || windowSize === DeviceWidth.XSmall.name;

    if (compactView) {
      return <SecureMessagesCompact location={ this.props.location } filteredThreads={listItems} />;
    }
    return <SecureMessages location={ this.props.location } filteredThreads={listItems} />;
  }

  render() {
    return this.getComponentBySize();
  }
}

SecureMessagePage.propTypes = {
  dispatch: PropTypes.func,
  windowSize: PropTypes.string,
  timeZone: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  language: PropTypes.string,
  patientId: PropTypes.number.isRequired,
  location: PropTypes.object,
  threads: PropTypes.array,
  filter: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  windowSize: state.window.size,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  language: state.language.languageCode,
  patientId: state.profile.patient.patientId,
  location: ownProps.location,
  threads: state.secureMessage.threads,
  filter: state.secureMessage.filter,
});

export default connect(mapStateToProps)(SecureMessagePage);